import { Component, type ErrorInfo, type PropsWithChildren, type ReactNode } from "react";

import type { Telemetry } from "../shared/telemetry/telemetry.js";
import { Button } from "../shared/ui/button.js";

interface ErrorBoundaryProps extends PropsWithChildren {
  readonly telemetry: Telemetry;
}

interface ErrorBoundaryState {
  readonly failed: boolean;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  public override state: ErrorBoundaryState = { failed: false };

  public static getDerivedStateFromError(): ErrorBoundaryState {
    return { failed: true };
  }

  public override componentDidCatch(error: Error, info: ErrorInfo): void {
    this.props.telemetry.captureError(error, {
      componentStack: info.componentStack ?? "unavailable",
    });
  }

  public override render(): ReactNode {
    if (!this.state.failed) return this.props.children;
    return (
      <main className="centered-layout">
        <section className="state-panel" aria-labelledby="unexpected-error-title">
          <p className="eyebrow">Recoverable error</p>
          <h1 id="unexpected-error-title">TradingApp needs a fresh start</h1>
          <p>Your browser session is still safe. Reload the application to try again.</p>
          <Button onClick={() => window.location.reload()}>Reload TradingApp</Button>
        </section>
      </main>
    );
  }
}
